import script from "./editbeike.vue?vue&type=script&setup=true&lang=js"
export * from "./editbeike.vue?vue&type=script&setup=true&lang=js"

import "./editbeike.vue?vue&type=style&index=0&id=762dcc90&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-762dcc90"]])

export default __exports__